export default "__VITE_ASSET__768974bc__"